import { createFileRoute, notFound } from "@tanstack/react-router";

import { deviceModelsQueries } from "@/api/resources/deviceModels/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import DeviceModelPage from "@/components/DeviceModel/DeviceModelPage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute(
  "/_auth/workspaces/$workspace_id/custom-inventory/device-models/$device_model_id/",
)({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: `${i18n.t("navigation.custom-inventory")} - ${i18n.t("devices")}`,
        icon: <Icon.DEVICE />,
        path: "/workspaces/$workspace_id/custom-inventory/devices",
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id, device_model_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();

    const currentDeviceModel = await context.queryClient.ensureQueryData(deviceModelsQueries.byId(device_model_id));
    if (!currentDeviceModel) throw notFound();

    return currentDeviceModel;
  },
  component: DeviceModelPage,
});
